function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
},
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11,11 L7,11 L7,9 L10,9 L11,9 L11,11 Z M8.5,5 L9.5,5 C9.771,5 10,5.229 10,5.5 L10,7 L8,7 L8,5.5 C8,5.229 8.229,5 8.5,5 L8.5,5 Z M12,7.092 L12,5.5 C12,4.122 10.879,3 9.5,3 L8.5,3 C7.121,3 6,4.122 6,5.5 L6,7.092 C5.42,7.3 5,7.85 5,8.501 L5,11.499 C5,12.327 5.674,13 6.501,13 L11.499,13 C12.326,13 13,12.327 13,11.499 L13,8.501 C13,7.85 12.58,7.3 12,7.092 L12,7.092 Z"
}),
/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M6.78164912,0.238559106 L0.802687399,1.77658446 C0.247242366,1.89666451 -0.101573023,2.43802542 0.0262918559,2.98138766 L1.42257633,12.2325551 C1.68137484,13.9547032 2.83829627,15.4206805 4.47496671,16.1031355 L8.77122663,17.947365 C8.91545821,18.0174117 9.08526277,18.0174117 9.22949436,17.947365 L13.5257543,16.1031355 C15.1624247,15.4206805 16.3193461,13.9547032 16.5781447,12.2325551 L17.9734062,2.98138766 C18.1012711,2.43802542 17.7534786,1.89666451 17.1980336,1.77658446 L11.2190719,0.238559106 C9.75732057,-0.0796530354 8.24340041,-0.0796530354 6.78164912,0.238559106 Z"
}));

var SvgSingleSignOn = function SvgSingleSignOn(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgSingleSignOn;